<template>
  <div>
    <vue-element-loading :active="visible" :is-full-screen="true" />
    <form @submit="onsubmit">
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
        style="color:black!important"
      />

      <va-input
        v-model="password"
        type="password"
        :label="$t('auth.password')"
        :error="!!passwordErrors.length"
        :error-messages="passwordErrors"
      />

      <div class="auth-layout__options d-flex align--center justify--end">
        <!-- <va-checkbox v-model="keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/> -->
        <router-link class="recover-password-link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link>
      </div>
      <div v-if="msg" class="auth-error-message mt-2 mb-2">{{msg}}</div>
      <div class="d-flex justify--center mt-4">
        <button type="submit" class="login-btn">{{ $t('auth.login') }}</button>
      </div>

      <br />
    </form>
  </div>
</template>

<script>
import store from '../../../store'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  name: 'login',
  components: {
    VueElementLoading,
  },
  data () {
    return {
      visible: false,
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
      message: '',
      msg: '',
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    onsubmit (evt) {
      this.visible = true
      this.emailErrors = this.email ? [] : ['email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      // if (!this.formReady) {
      //   return
      // }
      // this.$router.push({ name: 'dashboard' })
      var data = {}
      data['email'] = this.email
      data['password'] = this.password

      // console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/admin/signin',
        data: data,
      })
        .then(response => {
          this.visible = false
          this.status = response.data.status
          this.msg = response.data.msg

          if (this.status === true) {
            store.commit('loginUser')
            console.log('first', response.data.userType)
            this.$store.commit('userData', response.data.data)
            store.commit('userType', response.data.usertype)
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('userType', response.data.usertype)
            localStorage.setItem('userName', response.data.username)
            // localStorage.setItem("email", response.data.data.email);
            console.log(response)
            this.$router.push({ path: '/dashboard' })
          } else {
            this.msg = 'Email/Password is incorrect'
          }
        })
        .catch(err => {
          console.log(err)
          if (err.response.data.status === false) { this.msg = 'Email/Password is incorrect' }
        })
    },
  },
}
</script>

<style lang="scss">
.va-input__container__label
{
  color:black!important
}

.recover-password-link {
  color: #002c85 !important;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border-radius: 4px;

  &:hover {
    color: #40e583 !important;
    background-color: rgba(0, 44, 133, 0.05);
    text-decoration: none;
  }
}

.auth-error-message {
  color: #e34b4a;
  font-size: 0.85rem;
  text-align: center;
  font-weight: 500;
  background-color: rgba(227, 75, 74, 0.1);
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid rgba(227, 75, 74, 0.2);
}

.login-btn {
  background: linear-gradient(135deg, #002c85 0%, #001a54 100%) !important;
  color: white !important;
  border: none;
  padding: 10px 32px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 44, 133, 0.2);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  outline: none;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 44, 133, 0.35);
    background: linear-gradient(135deg, #0037a5 0%, #002c85 100%) !important;
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 44, 133, 0.2);
  }
}
</style>
